'use client';
import { Button, FontIcon } from '@intigral/shared';
import styles from './mbuttons.module.sass';
import cn from 'classnames';
import { useMediaQuery } from '@intigral/hooks/dom/useMediaQuery/useMediaQuery';
import { ButtonProps } from '@intigral/shared/components/Button';

export interface MovieButtonsProps extends React.HTMLAttributes<HTMLDivElement> {
    play?: React.ReactElement;
    progress?: string;
    watchlist?: ButtonProps;
    /** TODO: make wathclist button consistent everywhere */
    watchlistButton?: React.ReactElement;
    page?: ButtonProps;
    trailer?: ButtonProps;
    download?: ButtonProps;
    reminderButton?: React.ReactElement;
}

export const MovieButtons = ({
    play,
    progress,
    watchlist,
    watchlistButton,
    page,
    trailer,
    download,
    className,
    reminderButton,
    ...props
}: MovieButtonsProps) => {
    const isMobile = useMediaQuery('(max-width: 924px)');

    return (
        <div className={cn(className, styles.controls)} {...props}>
            {play && (
                // <LinkWrapper link={play}>
                //     <Button {...play} compact className={styles.play} LinkComponent="">
                //         {play.children}
                //         <FontIcon name="play-outline" size="small" md="small"></FontIcon>
                //         {progress && (
                //             <span className={styles.progress}>
                //                 <i style={{ width: progress }} />
                //             </span>
                //         )}
                //     </Button>
                // </LinkWrapper>
                <div className={styles.play}>
                    {play}
                    {progress && (
                        <span className={styles.progress}>
                            <i style={{ width: progress }} />
                        </span>
                    )}
                </div>
            )}
            {reminderButton && (
                <div className={styles.play} data-test-id="reminder-button">
                    {reminderButton}
                </div>
            )}
            {trailer && !isMobile && (
                <Button
                    {...trailer}
                    social={!trailer.children ? true : false}
                    secondary
                    compact
                    className={isMobile ? styles.trailer : ''}
                    data-test-id="trailer-button"
                >
                    {trailer.children && <span className={styles.label}>{trailer.children}</span>}
                    <FontIcon name="play-outline" size="small" md="small"></FontIcon>
                </Button>
            )}
            {watchlist && (
                <Button
                    {...watchlist}
                    // social={isMobile || !watchlist.children ? true : false}
                    secondary
                    compact
                    {...(watchlist.icon ? {} : {})}
                    data-test-id="watchlist-button"
                >
                    {watchlist.children && <span className={styles.label}>{watchlist.children}</span>}
                    {watchlist.icon && <FontIcon name={watchlist.icon} size="smaller" md="small" />}
                </Button>
            )}
            {watchlistButton && watchlistButton}
            {page && (
                <Button {...page} social secondary compact data-test-id="overlay-button">
                    <FontIcon name="info" size="smaller" md="smaller"></FontIcon>
                </Button>
            )}
            {download && isMobile && (
                <Button {...download} secondary>
                    {download.children && <span className={styles.label}>{download.children}</span>}
                    <FontIcon name="download" size="small" md="small" />
                </Button>
            )}
        </div>
    );
};
